import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  loadContactCardAction
} from "../../../redux/actions/contacts.actions";
import "./styles.scss";
import ContactCardDetail from "./ContactCardDetail";
import DocumentMeta from "react-document-meta";

export class ContactCardPage extends React.Component {
  componentDidMount() {
    const { slug } = this.props.match.params;
    this.props.loadContactCardAction(slug);
  }



  render() {
    const { contact, loggedIn, loggedInUser } = this.props;

    const meta = {
      title: "myHelloHello",
      description: "Please join me on myHelloHello! The only worldwide contact directory!",
      canonical: "http://www.myhellohello.com",
      url: "http://www.myhellohello.com",
      type: "article",
      image: "https://myhellohellostatic.s3-eu-west-1.amazonaws.com/media/generic_social_contact_card_sm.jpg"
    }

    return (
      <div>
        <DocumentMeta {...meta} />
        <ContactCardDetail
          contact={contact}
          loggedIn={loggedIn}
          loggedInUser={loggedInUser}
        />
      </div>

    );
  }
}

const mapStateToProps = state => ({
  loggedInUser: state.profile.profile,
  contact: state.contacts.selectedContact,
  loggedIn: state.auth.loggedIn
});

export default withRouter(connect(
  mapStateToProps,
  { loadContactCardAction })
(ContactCardPage));



// WEBPACK FOOTER //
// ./src/components/pages/ContactCardPage/ContactCardPage.jsx